import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { InstitutionTitleComponent } from '../institution-title/institution-title.component';
import { UserProfileService } from '../../services/user-profile.service';
import { SessionService } from '../../services/session.service';

@Component({
  selector: 'aaos-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  isLoggedIn: boolean;

  constructor(
    private userProfileService: UserProfileService,
    private sessionService: SessionService) { }

  ngOnInit() {
    this.userProfileService.getIsAuthenticated().subscribe((response) => this.isLoggedIn = response);
  }

  logout() {
    this.sessionService.clearAllSessionStorage();
    window.location.href = '../api/authentication/signout';
  }

}
